(function () {
    'use strict';

    angular
        .module('rms.common')
        .filter('displayFilter', displayFilter);

    function displayFilter(FILTER_OPERATOR_CONSTANT, lodash, $filter, GenericModel) {
        return function (filter, $scope) {

            var filterService = $scope.listFilterService.getFilterService();
            var selectedFilter = filterService.getFilter(filter.field);
            if (!selectedFilter) {
                var displayValue = lodash.get(filter, 'display_value', null);
                return !!displayValue ? displayValue : '...';
            }

            var filterOptions = $scope.listFilterService.getFilterService().getFilterOptionValues(selectedFilter.type);
            var filterOption = lodash.find(filterOptions, function (item) {
                return item.operator == filter.operator;
            });

            var operatorLabel = filterService.getLabel('operator_label.' + filterOption.operator, lodash.get(selectedFilter, 'settings.filter_display_override.' + filterOption.operator));

            switch (filterOption.operator) {
                case FILTER_OPERATOR_CONSTANT.BETWEEN:
                case FILTER_OPERATOR_CONSTANT.RANGE:
                    if (selectedFilter.type === 'date') {
                        var lowerDateValue = $filter('date')(filter.value.lower, lodash.get(selectedFilter, 'format', 'dd/MM/yyyy'));
                        var upperDateValue = $filter('date')(filter.value.upper, lodash.get(selectedFilter, 'format', 'dd/MM/yyyy'));
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, lowerDateValue, upperDateValue]);
                    } else {
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, filter.value.lower, filter.value.upper]);
                    }
                case FILTER_OPERATOR_CONSTANT.IS:
                case FILTER_OPERATOR_CONSTANT.IN:
                case FILTER_OPERATOR_CONSTANT.NOT_IN:
                case FILTER_OPERATOR_CONSTANT.IN_ALL:
                case FILTER_OPERATOR_CONSTANT.NOT_IN_ALL:
                    var selectedOptionValue = null;
                    if (filterOption.options) {
                        selectedOptionValue = lodash.find(filterOption.options.data, function (item) {
                            return item.value == filter.value;
                        });
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, selectedOptionValue.label]);
                    } else {
                        if (selectedFilter.options) {
                            var labelArray = [];
                            var isDatasource = lodash.has(selectedFilter, 'options.datasource', false);
                            var hasData = lodash.has(selectedFilter, 'options.data', false);

                            var getLabelReducer = function(previous, current) {
                                if (lodash.indexOf(filter.value, current.value.toString()) >= 0) {
                                    previous.push(current.label);
                                }
                                return previous;
                            };

                            // added for multiple enum filter TMS-545
                            var getLabelReducerMultipleFilterValue = function(enumKey) {
                                return function(previous, current) {
                                    var _subSetting = lodash.get(selectedFilter, ['settings', 'sub_settings', enumKey].join('.'), {})
                                    var isHidden = lodash.get(_subSetting, 'hidden', false);
                                    if (isHidden) {
                                        return previous;
                                    }

                                    if (lodash.isArray(filter.value[enumKey])) {
                                        if (lodash.indexOf(filter.value[enumKey], current.value.toString()) >= 0) {
                                            var previousValues = lodash.get(previous, enumKey, []);
                                            lodash.set(previous, enumKey, previousValues.concat(current.label));
                                        }
                                    } else {
                                        if (filter.value[enumKey] == current.value.toString()) {
                                            lodash.set(previous, enumKey, current.label);
                                        }
                                    }
                                    return previous;
                                };
                            };

                            // Fix ENUM REMOTE
                            if (!hasData && isDatasource) {

                                if (filter.data) {
                                    labelArray = filter.data.reduce(getLabelReducer, []);
                                }
                            } else {
                                if (lodash.isArray(selectedFilter.options.data)) { // added for multiple enum filter TMS-545
                                    labelArray = selectedFilter.options.data.reduce(getLabelReducer, []);
                                } else { // added for multiple enum filter TMS-545
                                    var subSettings = angular.copy(lodash.get(selectedFilter, 'settings.sub_settings', {}));
                                    var subSettingsWithKeys = lodash.reduce(subSettings, function(carry, subSetting, _key) {
                                        subSetting['key'] = _key
                                        carry[_key] = subSetting
                                        return carry;
                                    }, {});
                                    var dataKeys = Object.keys(selectedFilter.options.data);

                                    var labelObject = angular.copy(lodash.get(filter, 'value', {}));
                                    labelObject = $filter('objWithoutKeys')(labelObject, dataKeys); // remove value from keys that is going to get the label from
                                    lodash.forEach(dataKeys, function (dataKey) {
                                        labelObject = lodash.reduce(
                                            selectedFilter.options.data[dataKey],
                                            getLabelReducerMultipleFilterValue(dataKey),
                                            labelObject
                                        );
                                    });
                                    var sortedLabelObjectArr = $filter('sortObjArrToArrBySamplingData')(labelObject, subSettingsWithKeys, [['order'], ['asc']], 'key');
                                    labelArray = lodash.map(sortedLabelObjectArr, function(_sortedLabelObjectArr) {
                                        return lodash.isArray(_sortedLabelObjectArr) ? _sortedLabelObjectArr.join(', ') : _sortedLabelObjectArr;
                                    });

                                    var subSettingsKeys = Object.keys(lodash.get(selectedFilter, 'settings.sub_settings', {}));
                                    var sortedSubSettingsKeys = $filter('sortObjArrToArrBySamplingData')(subSettingsKeys, subSettingsWithKeys, [['order'], ['asc']], 'key');
                                    var subSettingsLabels = lodash.map(sortedSubSettingsKeys, function (sortedSubSettingsKey) {
                                        return lodash.get(selectedFilter, ['settings', 'sub_settings', sortedSubSettingsKey, 'label'].join('.'), 'filters.label');
                                    });

                                    return $filter('stringFormat')(
                                        operatorLabel,
                                        // subSettingsLabels.slice(0, 1)
                                        //     .concat(labelArray.slice(0, 1).join(', '))
                                        //     .concat(subSettingsLabels.slice(1))
                                        //     .concat(labelArray.slice(1).join(', '))
                                        // a = ["Language", "Spoken Proficiency", "Written Proficiency"];
                                        // b = ["English", "1 - Noob, 2 - Okay", "3 - Pro, 4 - Godly, 5 - Hacker"]
                                        // Turn into ["Language", "English", "Spoken Proficiency", "1 - Noob, 2 - Okay", "Written Proficiency", "3 - Pro, 4 - Godly, 5 - Hacker"]
                                        // which fulfill {0} is {1} and {2} includes {3} and {4} includes {5}
                                        lodash.flatten(lodash.zip(subSettingsLabels, labelArray)) 
                                    );
                                }
                            }

                            return $filter('stringFormat')(operatorLabel, [selectedFilter.label, labelArray.join(', ')]);
                        } else {
                            return "";
                        }
                    }
                case FILTER_OPERATOR_CONSTANT.EXISTS:
                case FILTER_OPERATOR_CONSTANT.NOT_EXISTS:
                    return $filter('stringFormat')(operatorLabel, [selectedFilter.label]);
                default:
                    if (selectedFilter.type === 'date') {
                        var dateValue = $filter('date')(filter.value, lodash.get(selectedFilter, 'format', 'dd/MM/yyyy'));
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, dateValue]);
                    } else {
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, filter.value]);
                    }
            }
        }
    }
})();